import { LoadingIndicator } from "@jsq/ds/core";
import { FormPercentInput, FormSelect, FormTextInput } from "@jsq/ds/forms";
import { useCountryOptions } from "~/pages/Compliance/CaseDetailsDrawer/Profiles/common/AddressFields/CountryFormField/useCountryOptions";
import { JOINT_TYPE_OPTIONS } from "~/pages/Compliance/utils/accountTypeUtils";
import { fieldWrapStyle } from "../styles_vanilla.css";

interface Props {
  isRootProfile?: boolean;
}

export const JointProfileFields = ({ isRootProfile = false }: Props) => {
  const { loading: countriesLoading, countryOptions } = useCountryOptions();

  return (
    <>
      <div className={fieldWrapStyle}>
        <FormSelect
          name="jointType"
          label="Joint ownership type"
          placeholder="Select joint ownership type"
          full
        >
          <FormSelect.Section>
            {JOINT_TYPE_OPTIONS.map((opt) => (
              <FormSelect.Option key={opt.value} value={opt.value}>
                {opt.label}
              </FormSelect.Option>
            ))}
          </FormSelect.Section>
        </FormSelect>
      </div>
      <div className={fieldWrapStyle}>
        <FormTextInput label="Name" name="name" isFullWidth />
      </div>
      {!isRootProfile && (
        <div className={fieldWrapStyle}>
          <FormPercentInput label="Ownership percentage" name="ownershipPercentage" />
        </div>
      )}
      <div className={fieldWrapStyle}>
        {countriesLoading ? (
          <LoadingIndicator />
        ) : (
          <FormSelect
            name="domicileCountry"
            label="Domicile country"
            placeholder="Select country"
            full
          >
            <FormSelect.Section>
              {countryOptions.map((country) => (
                <FormSelect.Option key={country.id} value={country.code}>
                  {country.name}
                </FormSelect.Option>
              ))}
            </FormSelect.Section>
          </FormSelect>
        )}
      </div>
    </>
  );
};

export default JointProfileFields;
